export function shouldShowGreenTrunkComponent() {
  return /\.develop\.|localhost/.test(window.location.hostname);
}
